import { KeyValueModel } from "model";
import { EnumTipoPessoas } from 'model/enums/enum-tipo-pessoas';

export const FuncionarioMock: KeyValueModel[] = [
    new KeyValueModel(EnumTipoPessoas.Funcionario, "Funcionário"),
    new KeyValueModel(EnumTipoPessoas.FuncionarioFinanceiroSemCusto, "Funcionário Financeiro (Sem Custo)"),
    new KeyValueModel(EnumTipoPessoas.FuncionarioFinanceiro, "Funcionário Financeiro (Com Custo)"),
];
